import { baseApi, CUSTOMERS_TAG } from '@shared/api';

import {
  ICreateCustomerRequest,
  ICustomer,
  ICustomerResponse,
  IGetCustomerByIdResponse,
  IUpdateCustomerStatusRequest,
} from './customers.types';
import { IPagedResponse } from '@shared/api/interfaces';

interface IQueryParams {
  page?: number;
  size?: number;
}

export const customersApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getCustomersPaged: build.query<IPagedResponse<ICustomer>, IQueryParams>({
      query: params => ({
        url: '/customers',
        params,
      }),
      providesTags: [CUSTOMERS_TAG],
    }),
    createCustomer: build.mutation<ICustomerResponse, ICreateCustomerRequest>({
      query: body => ({
        url: '/customers',
        method: 'POST',
        body: body,
      }),
      invalidatesTags: [CUSTOMERS_TAG],
    }),
    updateCustomerStatus: build.mutation<void, IUpdateCustomerStatusRequest>({
      query: req => ({
        url: `/customers/${req.id}/status`,
        method: 'PATCH',
        body: req.body,
      }),
      invalidatesTags: [CUSTOMERS_TAG],
    }),
    getCustomerById: build.query<IGetCustomerByIdResponse, string>({
      query: id => ({
        url: `/customers/${id}`,
      }),
    }),
  }),
});

export const {
  useGetCustomersPagedQuery,
  useCreateCustomerMutation,
  useGetCustomerByIdQuery,
  useUpdateCustomerStatusMutation,
} = customersApi;
